import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import gsap from 'gsap';
import * as ScrollMagic from 'scrollmagic-with-ssr';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import './style.scss';
import HeroLandingV2 from '../../elements/HeroLanding_v2';
import Detail from '../../elements/InnerPageDetail';
import { getHeaderHeight, isMobileFun } from '../../utils/obj-utils';

export default function index(props) {
  const [flag, setFlag] = useState(false);
  const containerRef = useRef(null);
  const heroLandingRef = useRef(null);
  let once = true;
  const isMobile = isMobileFun();
  const routePath = isMobile ? props.fields.btn[0].fields.m_url.value || props.fields.btn[0].fields.url.value : props.fields.btn[0].fields.url.value;
  const background = props.fields.backColor.value;
  const id = props.fields.id.value;
  const [data, setData] = useState({
    isMobile,
    routePath,
    background,
    id
  });

  useImperativeHandle(props.eventRef, () => {
    return {
      sendEvent
    };
  });

  const sendEvent = () => {
    window.Dmp.sectionAction(data?.id);
    // 二级导航高亮所属变量
    console.log(props, '内饰');
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = props?.params?.pagename !== undefined ? props?.params?.pagename : '';
  };

  useEffect(() => {
    reset();
    const textElement = heroLandingRef.current.getElementsByClassName('text-container')[0];
    const panoramaElement = heroLandingRef.current.getElementsByClassName('panorama')[0];
    const windowHeight = document.documentElement.clientHeight;
    const headerHeight = getHeaderHeight();
    const timeline1 = gsap
      .timeline({ paused: true })
      .fromTo(containerRef.current.children[0], { opacity: 0 }, { opacity: 1, duration: 0.55, ease: 'power1.out' })
      .fromTo(containerRef.current.children[0], { scale: 0.6 }, { scale: 1, duration: 1 }, '<');
    const controller = new ScrollMagic.Controller();
    const scene1 = new ScrollMagic.Scene({
      triggerElement: containerRef.current,
      triggerHook: '0.8',
      duration: windowHeight - headerHeight
    })
      .on('progress', function (event) {
        timeline1.progress(event.progress);
      })
      .setTween(timeline1)
      .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
      triggerElement: containerRef.current,
      triggerHook: headerHeight / windowHeight,
      duration: '100%'
    })
      .on('progress', function (event) {
        if (event.progress >= 0.5 && once) {
          once = false;
          gsap
            .timeline()
            .fromTo(textElement, { opacity: 0, y: '-100%' }, { opacity: 1, y: 0, duration: 1.25 })
            .fromTo(panoramaElement, { opacity: 0, y: '-100%' }, { opacity: 1, y: 0, duration: 0.75 }, '<');
        }
      })
      .setPin(containerRef.current)
      .addTo(controller);

    return () => {
      timeline1.kill();
      scene1.remove();
      scene1.destroy();

      scene2.remove();
      scene2.destroy();

      controller.destroy();
    };
  }, []);

  const reset = () => {
    const textElement = heroLandingRef.current.getElementsByClassName('text-container')[0];
    const panoramaElement = heroLandingRef.current.getElementsByClassName('panorama')[0];
    textElement.style.opacity = 0;
    panoramaElement.style.opacity = 0;
  };

  return (
    <section>
      {flag && <Detail routePath={data?.routePath} close={() => setFlag(false)} />}
      <div className="Exterior_v2" style={{ background: data?.background }} ref={containerRef}>
        <HeroLandingV2 data={props} checkDetail={setFlag} ref={heroLandingRef} />
      </div>
      <div className="Exterior_v2-anchor" id={data?.id} />
    </section>
  );
}
